export const EMAILJS_USER_ID = '5VW8Y6sWbTqboSlQY';
export const EMAILJS_TEMPLATE_ID = 'template_0o1ru5s';
export const EMAILJS_SERVICE_ID = 'service_56qhkvs';
